import { action, runInAction, toJS } from 'mobx';
import store from '../store/index';
import _ from 'lodash';
import API, { getOperatorList } from '../api/index';
import globalStore from '@/stores';
import * as echarts from 'echarts';
import { Column, Loading, OverlayTrigger, PopOver, Table, Icon } from '@tencent/spaui';
import { nullDataOption, option, handleData, TASK_TYPE_TEXT_MAP } from '../config';
import RightShowDialogServices from '../components/RightShowDialog/services';
import OverflowHoverTip from '@/common-components/overflow-hover-tip';
import dayjs from 'dayjs';
import message from '@/utils/message';
import Progress from '@/components/Progress';
import { reportUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import { getRainbowCommonConfig } from '@/api/rainbow';

import { TaskScope } from '../model';


class BoardCardService {
  taskData = null
  taskOperateData = null;

  initTaskScope = async () => {
    const res = await getOperatorList();
    return !!res?.data?.scope;
  }

  @action
  initTaskType = () => {
    getRainbowCommonConfig('task_type_config').then((config) => {
      try {
        runInAction(() => {
          store.taskTypeList = config.list;
          store.taskTypeGroup = config.group;
        });
      } catch (error) {}
    });
  }

  // 获取任务分类配置列表
  getTaskTypeList = (groupType) => {
    if (groupType) {
      return toJS(store.taskTypeList?.filter((v) => store.taskTypeGroup?.[groupType]?.includes(v.value)) || []);
    }
    return toJS(store.taskTypeList || []);
  }

  // 获取某种类型包含的任务分类
  getTaskTypeByGroup = (groupType) => {
    return toJS(store.taskTypeGroup?.[groupType] || []);
  }

  // 轮询获取任务分类，主要用于filter
  fetchTaskTypeList = (groupType) => {
    return new Promise((resolve) => {
      const startTime = new Date().getTime();
      const maxEndTime = startTime + 60000;

      const interval = setInterval(() => {
        const taskTypeList = this.getTaskTypeList(groupType);
        if (taskTypeList.length) {
          clearInterval(interval);
          resolve(taskTypeList);
        } else if (new Date().getTime() > maxEndTime) {
          clearInterval(interval);
          resolve([]);
        }
      }, 1000);
    });
  }

  // 根据任务分类获取任务分组
  getTaskGroupType = (taskType) => {
    let groupType = '';
    Object.keys(store.taskTypeGroup).some((group) => {
      if (store.taskTypeGroup[group].includes(taskType)) {
        groupType = group;
        return true;
      }
      return false;
    });
    return groupType;
  };

  // 获取任务详情，以及任务详情页列表数据
  @action
  getGroupDetailData = (groupId, isCall = true) => {
    // isCall代表在点击放弃任务按钮时不调用任务详情接口只调用任务详情列表接口
    const { sortBy } = store;
    const isTeam = store.scope === TaskScope.team;
    let params = null;
    params = {
      task_group_id: groupId,
      ...sortBy,
      scope: store.scope,
    };
    if (!isTeam) {
      params.page = store.getGroupConfig.page;
      params.page_size = store.getGroupConfig.page_size;
    } else if(isTeam) {
      params.page = store.getTeamGroupConfig.page;
      params.page_size = store.getTeamGroupConfig.page_size;
    }
    // 获取任务详情列表数据
    API.getGroupTaskList({ data: params }).then((res) => {
      if(res.code === 0) {
        runInAction(() => {
          if(res.data.list.length !== 0) {
            this.getTasktailProcessorData(res.data.list);
          }
          if(!isTeam) {
            store.getGroupConfig = res.data.conf;
          }else if(isTeam) {
            store.getTeamGroupConfig = res.data.conf;
          }
          store.getGroupTaskList = res.data.list;
        });
        // 获取任务详情数据
        const taskList = res.data.list.map((item) => {
          return item.task_id;
        });
        const param = {
          task_group_id: groupId,
          task_id_list: taskList,
          scope: isTeam ? 1 : 0,
        };
        if(isCall) {
          API.getGroupDetail({ data: param }).then((res) => {
            RightShowDialogServices.changeDetailShow(true);
            if (res.code == 0) {
              runInAction(() => {
                store.taskGroupDetails = res.data;
              });
            }
          });
        }
      }
    });
  }

  // 获取任务详情待处理人列表
  @action
  getTasktailProcessorData = (arr) => {
    const isTeam = store.scope === TaskScope.team;
    const param = {
      scope: store.scope,
      task_id_list: arr.map((x) => x.task_id),
    };
    store.todoUserDetailListLoading = true;
    API.getProcessorList({ data: param }).then((res) => {
      runInAction(() => {
        if (res.code == 0) {
          if (isTeam) {
            store.getGroupTaskList = store.getGroupTaskList.map((x) => {
              x.todo_user_list = res?.data?.list?.filter((y) => y.task_id == x.task_id)
                .map((j) => {
                  return j.processor_name;
                })
                .join(',');
              return x;
            });
          }
        }
      });
    })
      .finally(() => {
        runInAction(() => {
          store.todoUserDetailListLoading = false;
        });
      });
  }

  @action
  getSummary = () => {
    store.TaskCenterTeamStore.loading = true;
    const team_id_list = store.TaskCenterTeamStore.teamId;
    API.getSummary({ data: { scope: store.scope, team_id_list: team_id_list.length !== 0 ? [...team_id_list] : undefined } }).then((res) => {
      runInAction(() => {
        store.TaskCenterTeamStore.loading = false;
      });
      if (res.code == 0) {
        const data = res.data;
        const totalTask = document.getElementById('totalTask');
        const myChart = echarts.init(totalTask);
        const todayTask = document.getElementById('todayTask');
        const myChart2 = echarts.init(todayTask);
        const willExpretTask = document.getElementById('willExpretTask');
        const myChart3 = echarts.init(willExpretTask);
        if (data.totalSummary?.totalCount) {
          myChart.setOption({ ...option, ...handleData(data, 'totalSummary') });
        } else {
          myChart.setOption({
            ...nullDataOption,
            graphic: {
              type: 'text',
              left: 'center',
              top: 'center',
              style: {
                text: '总任务暂无数据',
                textAlign: 'center',
                fill: '#000',
                width: 30,
                height: 30,
              },
            },
          });
        }
        if (data.todaySummary?.totalCount) {
          myChart2.setOption(handleData(data, 'todaySummary'));
        } else {
          myChart2.setOption(nullDataOption);
        }
        if (data.expireInNextWeekSummary?.totalCount) {
          myChart3.setOption(handleData(data, 'expireInNextWeekSummary'));
        } else {
          myChart3.setOption({
            ...nullDataOption,
            graphic: {
              type: 'text',
              left: 'center',
              top: 'center',
              style: {
                text: '七天内将过期暂无数据',
                textAlign: 'center',
                fill: '#000',
                width: 30,
                height: 30,
              },
            },
          });
        }
      }
    });
  }

 // 获取进行中任务数量
 @action
  getActiveCount = (isTeam) => {
    const { company_id, user_id, agency_list } = globalStore.account;
    const param = {
      agency_uid_list: agency_list.map((x) => x.agency_uid),
      company_id,
      scope: isTeam ? 1 : 0,
      user_id,
      page: 1,
      page_size: 100,
    };
    this.initTask = API.getTaskSummary({ data: param }).then((res) => {
      if (res.code == 0) {
        const list = res.data?.list || [];
        const summaryList = ['operate', 'learn', 'remind'];

        const summary = summaryList.reduce((map, type) => {
          let count = 0;
          list.forEach((v) => {
            if (this.getTaskTypeByGroup(type).includes(Number(v.task_type_id))) {
              count += v.todo;
            }
          });
          return { ...map, [type]: count };
        }, {});
        runInAction(() => {
          store.activeCount = {
            ...store.activeCount,
            [isTeam ? 'team' : 'personal']: summary,
          };
        });
      }
    });
  }

  // 改变状态
  @action
  updateTaskStatus = (taskId, status, onSuccess, options = {}) => {
    const { isClose, id, title } = options;
    const { remark } = store;
    const param = {
      status,
      update_comment: remark ? remark : undefined,
      task_id_list: [...taskId],
    };
    API.updateTaskStatus({ data: param }).then((res) => {
      if (res.code !== 0) {
        message.success('修改成功');
        this.isRemark = '';
        if (isClose) {
          RightShowDialogServices.changeDetailShow(false);
        }
        onSuccess();
      }
    });
    const data = {
      behavior: '点击“忽略”',
      page1: '任务',
      page2: '任务中心',
      page3: TASK_TYPE_TEXT_MAP[store.group],
      relation_id: id,
      relation_name: title,
    };
    reportUserBehaviorCgi({ data });
  }
  // 获取详情
  @action
  getDetails = (id, title) => {
    const data = {
      behavior: '点击“标题”',
      page1: '任务',
      page2: '任务中心',
      page3: TASK_TYPE_TEXT_MAP[store.group],
      relation_name: title,
      relation_id: id,
    };
    reportUserBehaviorCgi({ data });
    const param = {
      task_id: id,
    };
    API.getTaskDetails({ data: param }).then((res) => {
      if (res.code == 0) {
        RightShowDialogServices.changeDetailShow(true);
        runInAction(() => {
          store.taskDetails = res.data;
        });
      }
    });
  }

  @action
  onOpen = (event, open) => {
    ;(store.minWidth = open ? 240 : 90), (store.open = open);
  }
  // 团队改变
  @action
  handleTeamIds = (e, teamId) => {
    store.TaskCenterTeamStore.teamId = teamId;
  }
  @action
  handleTeamOpen = (e, open) => {
    const {
      TaskCenterTeamStore: { teamId },
    } = store;
    if (open) {
      store.oldTeamId = teamId;
    } else {
      if (!_.isEqual(_.sortBy(store.oldTeamId), _.sortBy(teamId))) {
        this.getSummary();
      }
    }
  }

  // 学习任务状态
  handleDataStatus = (item, data, f) => {
    const obj = data.find((x) => item == x.task_id) || {};
    return !obj.show_deal || obj.status_value !== 0 || !obj.support_ignore;
  }

  // 完成进度的Tip: 是否学习 / 是否达标
  columnsRenderSub_Finished = (type, name, value, data) => {
    let result = value;
    if (type !== 'head') {
      if (name == 'is_completed') {
        result = value ? '是' : '否';
      }
    }
    return result;
  }

  // 点击去处理埋点
  toDealWith=(id, title) => {
    const data = {
      behavior: '点击“去处理”',
      page1: '任务',
      page2: '任务中心',
      page3: TASK_TYPE_TEXT_MAP[store.type],
      relation_id: id,
      relation_name: title,
    };
    reportUserBehaviorCgi({ data });
  };

  /**
   * 计算完成度
   * @param {number} current 完成值
   * @param {number} target 目标值
   * @param {string} monitor_operator 操作符
   *    GREATER_EQUALS: 大于等于
   *    GREATER: 大于
   *    [以下暂未用到]
   *    LESS_EQUALS: 小于等于
   *    LESS: 代表小于
   *    EQUALS: 代表等于
   * @return {
   *    percent: 0~100,
   *    text: "0%""
   * }
   */
  computedJindu = (current, target, monitor_operator = '') => {
    current = +current;
    target = +target;
    if (target !== 0) {
      const percent = Math.floor((current / target) * 100);
      return {
        percent,
        text: `${current}/${target}`,
      };
    }
    // 1、大于0的任务，任务进度一开始显示0%，当消耗大于0的时候，任务进度显示为100%
    // 2、大于等于0的任务，任务进度一开始就显示100%，任务显示为已完成的进度
    switch (monitor_operator) {
      case 'GREATER_EQUALS':
        return {
          percent: 100,
          text: `${current}/0`,
        };
      case 'GREATER':
        if (current === 0) {
          return {
            percent: 0,
            text: `${current}/0`,
          };
        }
        return {
          percent: 100,
          text: `${current}/0`,
        };
      default:
        // 兜底 (旧数据没有这个字段，时间统计也没有这个字段)
        return {
          percent: 100,
          text: `${current}/0`,
        };
    }
  }

  // 渲染列表
  columnsRender = (type, name, value, data) => {
    const {
      account: { feature_flag },
    } = globalStore;
    let result = value;
    if (type !== 'head') {
      switch (name) {
        case 'task_id':
          result = (
            <span>
              {data.collect_task_status ? (
                <>
                  <Icon style={{ width: '12px', height: '12px', marginRight: 5 }} name="star-colored" />
                  {value}
                </>
              ) : (
                value
              )}
            </span>
          );
          break;
        case 'title':
          result = (
            <OverflowHoverTip tip={value}>
              <a
                data-computed-dom
                style={{ cursor: 'pointer', maxWidth: '260px', height: '100%', textOverflow: 'ellipsis', display: 'inline-block', borderRadius: '8px', whiteSpace: 'nowrap', overflow: 'hidden', marginTop: '4px' }}
                onClick={() => this.getDetails(data.task_id, data.title)}
                data-report="task-detail.show.title"
                data-report-extra={`relation_key:task_id;relation_value:${data.task_id}`}
              >
                {value}
              </a>
            </OverflowHoverTip>
          );
          break;
        case 'end_date':
          result = `${data.begin_date}至${data.end_date}`;
          break;
        case 'update_comment':
          result = (
            <OverflowHoverTip className="todo_user_list" tip={value}>
              <span data-computed-dom style={{ width: '200px', height: '100%', textOverflow: 'ellipsis', display: 'inline-block', borderRadius: '8px', whiteSpace: 'nowrap', overflow: 'hidden', marginTop: '4px' }}>
                {value || '-'}
              </span>
            </OverflowHoverTip>
          );
          break;
        case 'todo_user_list':
          result = store.todoUserListLoading ? (
            <Loading display="center" />
          ) : (
            <OverflowHoverTip className="todo_user_list" tip={value}>
              <span data-computed-dom style={{ width: '200px', height: '100%', textOverflow: 'ellipsis', display: 'inline-block', borderRadius: '8px', whiteSpace: 'nowrap', overflow: 'hidden', marginTop: '4px' }}>
                {value}
              </span>
            </OverflowHoverTip>
          );
          break;
        case 'jindu':
          if (data.total_time || data.core_task_process_info?.monitor_target_count) {
            if (data.task_type_id == 2 || data.task_type_name == '必修课程') {
              const jindu = this.computedJindu(data.learned_time, data.total_time);
              // 必修课程2
              result = (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <PopOver className="taskCenterHoverTable">
                      <Table data={data.course_info_list}>
                        <Column key="course_name" minWidth={80} name="course_type">
                          课程类型
                        </Column>
                        <Column key="course_name" minWidth={100} name="course_name">
                          课程名称
                        </Column>
                        <Column key="is_completed" minWidth={80} name="is_completed" render={this.columnsRenderSub_Finished}>
                          是否学习
                        </Column>
                      </Table>
                    </PopOver>
                  }
                >
                  <div className="progress progress-line progress-status-normal progress-show-info progress-default">
                    <div className={'progress-text text-position-top'}>{jindu.text}</div>
                    <div className="progress-outer">
                      <div className="progress-inner">
                        <div className="progress-bg" style={{ width: `${jindu.percent}%`, height: '5px' }}></div>
                      </div>
                    </div>
                  </div>
                </OverlayTrigger>
              );
            } else if (data.task_type_id == 1) {
              const jindu = this.computedJindu(data.learned_time, data.total_time);

              result = <Progress textPosition="top" percent={jindu.percent} style={{ height: '5px' }} text={jindu.text} />;
            } else if (data.is_system_monitor) {
              const jindu = this.computedJindu(data.core_task_process_info?.monitor_completed_count, data.core_task_process_info?.monitor_target_count, data.core_task_process_info?.monitor_operator);

              if (data.core_task_process_info.period_type == 1) {
                result = (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <PopOver className="taskCenterHoverTable">
                        <Table data={data.core_task_process_info.core_task_process_detail?.map((x) => ({ ...x, monitor_target_name: data.core_task_process_info.monitor_target_name }))}>
                          <Column key="monitor_target_name" maxWidth={100} name="monitor_target_name">
                            任务指标
                          </Column>
                          <Column key="date" maxWidth={100} name="date">
                            达标日期
                          </Column>
                          <Column key="completed" maxWidth={80} name="completed">
                            达标数
                          </Column>
                          <Column key="is_completed" maxWidth={80} name="is_completed" render={this.columnsRenderSub_Finished}>
                            是否达标
                          </Column>
                        </Table>
                      </PopOver>
                    }
                  >
                    <div className="progress progress-line progress-status-normal progress-show-info progress-default">
                      <div className={'progress-text text-position-top'}>{jindu.text}</div>
                      <div className="progress-outer">
                        <div className="progress-inner">
                          <div className="progress-bg" style={{ width: `${jindu.percent}%`, height: '5px' }}></div>
                        </div>
                      </div>
                    </div>
                  </OverlayTrigger>
                );
              } else {
                result = (
                  <div className="progress progress-line progress-status-normal progress-show-info progress-default">
                    <div className={'progress-text text-position-top'}>{jindu.text}</div>
                    <div className="progress-outer">
                      <div className="progress-inner">
                        <div className="progress-bg" style={{ width: `${jindu.percent}%`, height: '5px' }}></div>
                      </div>
                    </div>
                  </div>
                );
              }
            } else {
              result = '-';
            }
          } else if (data.task_type_id == 9) {
            const value = data.status_value === 1 || data.status_value === 2 ? 1 : 0;
            // UNFINISHED(0, "未处理"), FINISHED(1, "已完成"), MARK_FINISHED(2, "标记完成"), IGNORED(3, "已忽略"), EXPIRED(4, "过期"), NOT_STARTED(5, "未开始");
            result = <Progress textPosition="top" percent={value * 100} style={{ height: '5px' }} text={`${value}/${1}`} />;
          } else {
            result = '-';
          }
          break;
      }
    } else if (name == 'jindu') {
      result = (
        <>
          {value}
          <OverlayTrigger placement="top" overlay={<PopOver>当日下发的任务，次日统计数据。数据最后更新时间：{dayjs().add(1, 'day')
            .format('YYYY-MM-DD')}</PopOver>}>
            <i className="spaui-icon icon-help"></i>
          </OverlayTrigger>
        </>
      );
    } else {
      result = value;
    }
    return result || '-';
  }
  // 运营任务列表渲染
  columnsOperateRender=(type, name, value, data) => {
    const {
      account: { feature_flag },
    } = globalStore;
    let result = value;
    if (type !== 'head') {
      switch (name) {
        case 'task_group_id':
          result = (
              <span>
                {data.collect_task_status ? (
                  <>
                    <Icon style={{ width: '12px', height: '12px', marginRight: 5 }} name="star-colored" />
                    {value}
                  </>
                ) : (
                  value
                )}
              </span>
          );
          break;
        case 'title':
          result = (
                <OverflowHoverTip tip={value}>
                  <a
                    data-computed-dom
                    style={{ cursor: 'pointer', maxWidth: '260px', height: '100%', textOverflow: 'ellipsis', display: 'inline-block', borderRadius: '8px', whiteSpace: 'nowrap', overflow: 'hidden', marginTop: '4px' }}
                    onClick={() => this.getGroupDetailData(data.task_group_id)}
                    data-report="task-detail.show.title"
                    data-report-extra={`relation_key:task_group_id;relation_value:${data.task_group_id}`}
                  >
                    {value}
                  </a>
                </OverflowHoverTip>
          );
          break;
        case 'todo_user_list':
          result = store.todoUserListLoading ? (
              <Loading display="center" />
          ) : (
              <OverflowHoverTip className="todo_user_list" tip={value}>
                <span data-computed-dom style={{ width: '200px', height: '100%', textOverflow: 'ellipsis', display: 'inline-block', borderRadius: '8px', whiteSpace: 'nowrap', overflow: 'hidden', marginTop: '4px' }}>
                  {value}
                </span>
              </OverflowHoverTip>
          );
          break;
        case 'end_date':
          result = `${data.begin_date}至${data.end_date}`;
          break;
      }
    } else {
      result = value;
    }
    return result || '-';
  }
  @action
  changeRemarkShow = (id, taskStatus, onSuccess, options = {}) => {
    const { isClose, isRemark, id: relationId, title } = options;
    if (isRemark !== 3) {
      store.remarkShow = true;
      this.id = id;
      this.isRemark = isRemark;
      this.taskStatus = taskStatus;
      this.isColse = isClose;
    } else {
      this.updateTaskStatus(id, taskStatus, onSuccess, { isClose, id: relationId, title });
    }
    const data = {
      behavior: '点击“标记完成”',
      page1: '任务',
      page2: '任务中心',
      page3: TASK_TYPE_TEXT_MAP[store.group],
      relation_id: relationId,
      relation_name: title,
    };
    reportUserBehaviorCgi({ data });
  }
  // 收藏任务
  collectTask = (task_id_list, status, onSuccess, options = {}) => {
    const { id, title } = options;
    const str = status ? '收藏任务成功' : '取消收藏';
    API.collectTask({ data: { task_id_list: [...task_id_list], status, collect_type: 1 } }).then((res) => {
      if (res.code == 0) {
        message.success(str);
        onSuccess();
      }
    });
    const data = {
      page1: '任务',
      page2: '任务中心',
      page3: TASK_TYPE_TEXT_MAP[store.group],
      behavior: '点击“收藏任务”',
      relation_id: id,
      relation_name: title,
    };
    reportUserBehaviorCgi({ data });
  }
  collectOperateTask = (task_id_list, status, onSuccess, options = {}) => {
    const str = status ? '收藏任务成功' : '取消收藏';
    API.collectTask({ data: { task_id_list: [...task_id_list], status, collect_type: 2 } }).then((res) => {
      if (res.code == 0) {
        message.success(str);
        onSuccess();
      }
    });
    const data = {
      behavior: '点击“收藏任务”',
      page1: '任务',
      page2: '任务中心',
      page3: TASK_TYPE_TEXT_MAP[store.group],
      relation_id: options.id,
      relation_name: options.title,
    };
    reportUserBehaviorCgi({ data });
  }
  @action
  handleRemark = (e) => {
    store.remark = e.target.value;
  }
  onRemarkSubmit = (onSuccess) => {
    if (this.isRemark == 1 && store.remark.length < 1) {
      message.warn('请确认备注, 1~1000个字符');
      return;
    }
    this.updateTaskStatus(this.id, this.taskStatus, onSuccess, { isClose: this.isColse });
    this.handleRemarkClose();
  }
  @action
  handleRemarkClose = () => {
    store.remarkShow = false;
    store.remark = '';
    this.id = undefined;
    this.taskStatus = undefined;
  }

  /**
   * @description 获取团队列表
   */
  @action
  getOrganizationList = () => {
    const { account } = globalStore;
    const { company_id } = account;
    API.getOrganizationList({
      data: {
        company_id,
      },
    }).then((res) => {
      const { code, data } = res;
      if (code === 0) {
        runInAction(() => {
          store.organizationTree = data;
        });
      }
    });
  }
}

export default new BoardCardService();
